module.exports = __webpack_public_path__ + "img/W-G31.630634e6.jpg";